import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ApiSettings = lazy(() =>
  import("@scenes/ApiSettings/").then((module) => ({
    default: module.ApiSettingsForNro,
  }))
);

export const apiSettingsNRO: NavigationRoutingObject = {
  Component: ApiSettings,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("rest-apis-sidebar-pill-menu-option", "APIs and Identifiers"),
  pageNameForTracking: () => "APIs and Identifiers",
  getDeveloperNavigationAllowed: () => true,
  featureLimitationKeys: ["can_only_view_gated_feature"],
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("api-keys-api-settings", "API Settings")],
      description: t("previously-api-settings", 'Previously "API Settings"'),
    },
    {
      keywords: [t("activity-log-developer-console", "Developer Console")],
      description: t("previously-developer-console", 'Previously in "Developer Console"'),
    },
    {
      keywords: [
        t("api-and-identifiers-alt-keyword-1", "API keys"),
        t("api-and-identifiers-alt-keyword-2", "app identifiers"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
